import React from "react";
import "../../assets/css/layout.css";
import "../../assets/css/main.css";
import "../../assets/css/common.css";
import "../../assets/css/sub.css";
import "../../assets/css/slick.css";
import allBtn from "../../assets/img/common/all_btn1.png";
import allCross from "../../assets/img/common/all_cross1.png";
import orLine1 from "../../assets/img/or_line1.png";
import walkBest from "../../assets/img/walk_best.png";
{/* <!--
import ceoStep from "../../assets/img/ceo_step1.png";
import ceoStep2 from "../../assets/img/ceo_step2.png";
import ceoStep3 from "../../assets/img/ceo_step3.png";
import ceoStep4 from "../../assets/img/ceo_step4.png";
--> */}

import step_pc_1 from "../../assets/img/step_pc_1.jpg";
import step_pc_2 from "../../assets/img/step_pc_2.jpg";
import step_pc_3 from "../../assets/img/step_pc_3.jpg";
import step_pc_4 from "../../assets/img/step_pc_4.jpg";

import home from "../../../src/assets/img/icon_home.png";
import { routes } from "../../lib/routes";
import { Link } from "react-router-dom";
import SideBar from "../../components/common/SideBar";
export default function CompanyIntroduction() {
  const dropDownFirstTab = () => {
    let clickFirstTab = document.getElementById("myDropdown1");
    if (clickFirstTab.className === "dropdown-content") {
      clickFirstTab.className = "dropdown-content show";
    } else {
      clickFirstTab.className = "dropdown-content";
    }
  };
  const dropDownSecondTab = () => {
    let clickSecondTab = document.getElementById("myDropdown2");
    if (clickSecondTab.className === "dropdown-content") {
      clickSecondTab.className = "dropdown-content show";
    } else {
      clickSecondTab.className = "dropdown-content";
    }
  };
  return (
    <>
      <div
        className="all_box1"
        style={{
          position: "absolute",
          left: "50%",
          marginLeft: "500px",
          top: "75px",
        }}
      >
        <a href="#layer" className="btn-layer">
          <img src={allBtn} alt="전체메뉴" />
        </a>
      </div>
      {/* <!-- Start : layer-popup content --> */}
      <div id="layer" className="layer-wrap">
        <div className="pop-layer">
          <div className="pop-container">
            <div className="pop-conts">
              {/* <!-- content --> */}
              <div className="allmenu1">
                <h2 className="alltitl">All Menu</h2>
                <ul className="menulist">
                  <li>
                    <dl>
                      <dt>귀금속시세</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={routes.domesticPriceInquiry}>
                              국내시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.internationalPriceInquiry}>
                              국제시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.diamondPriceInquiry}>
                              다이아몬드 시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.securitiesPriceInquiry}>
                              유가증권
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>상품소개</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="/product/productall.html">원자재</Link>
                          </li>
                          <li>
                            <Link to="/product/securitiesgd.html">
                              유가증권
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>기념품 제작</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="#" href="/souvenir/inquiry.html">
                              제작문의 조회
                            </Link>
                          </li>
                          <li>
                            <Link to="#" href="/souvenir/inquiryRegister.html">
                              제작문의 등록
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>뉴스센터</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={"/newscenter/marketNoticeList.html"}>
                              뉴스
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>공지사항</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="#" href="/notice/announcementList.html">
                              공지사항
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>회사소개</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={routes.companyIntroduction}>
                              회사소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyGreeting}>CEO인사말</Link>
                          </li>
                          <li>
                            <Link to={routes.companyHistory}>회사연혁</Link>
                          </li>
                          <li>
                            <Link to={routes.companyBusinessIntroduction}>
                              사업소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyBrandIntroduction}>
                              브랜드소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyDirections}>오시는 길</Link>
                          </li>
                          {/* <li>
                            <Link to={routes.companyFranchiseInvitation}>
                              가맹점 모집
                            </Link>
                          </li> */}
                        </ul>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
              <Link to="#" href="#" className="btn-layerClose">
                <img src={allCross} alt="닫기" />
              </Link>
              {/* <!--// content--> */}
            </div>
          </div>
          {/* <!-- End : layer-popup content --> */}
        </div>
      </div>
      {/* <!--=============================================================**헤더 영역 끝-->
		<!-- wrap --> */}
      <div id="wrap">
        {/* <!-- 비쥬얼 박스 시작 --> */}
        <div className="svisual_box">
          <div className="sub_visual5_bg">
            <div className="subvisual_wrap">
              <dl className="sub_vtitl1">
                <dt>회사소개</dt>
                <dd>Company Introduction</dd>
              </dl>
              <div className="location_wrap">
                <div className="location_box">
                  <dl>
                    <dt className="home">
                      <Link to="/">
                        <img src={home} alt="home" />
                      </Link>
                    </dt>
                    <dd className="dep_menu1">
                      <button onClick={dropDownFirstTab} className="dropbtn">
                        회사소개
                      </button>
                      <div id="myDropdown1" className="dropdown-content">
                        <Link to={routes.domesticPriceInquiry}>시세조회</Link>
                        {/* <Link
                          style={{display: "none"}}
                        >
                          상품안내
                        </Link>
                        <Link style={{display: "none"}}>
                          기념품제작
                        </Link>
                        <Link
                        //   to="/newscenter/newsNoticeList.html"
                          style={{display: "none"}}
                        >
                          뉴스센터
                        </Link>
                        <Link
                          href="/notice/announcementList.html"
                          style={{display: "none"}}
                        >
                          공지사항
                        </Link> */}
                      </div>
                    </dd>
                    <dd className="dep_menu2">
                      <button onClick={dropDownSecondTab} className="dropbtn">
                        회사소개
                      </button>
                      <div id="myDropdown2" className="dropdown-content">
                        <Link to={routes.companyGreeting}>CEO 인사말</Link>
                        <Link to={routes.companyHistory}>회사연혁</Link>
                        <Link to={routes.companyBusinessIntroduction}>
                          사업소개
                        </Link>
                        <Link to={routes.companyBrandIntroduction}>
                          브랜드소개
                        </Link>
                        <Link to={routes.companyDirections}>오시는 길</Link>
                        {/* <Link to={routes.companyFranchiseInvitation}>
                          가맹점 모집
                        </Link> */}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_container">
          <div className="sub_container_wrap">
            {/* <!-- lnb start --> */}
            <SideBar />
            {/* <!-- lnb end -->
					<!-- contents start --> */}
            <div className="contents">
              <div className="con_titl1">
                <h4>회사소개</h4>
                <span>Company Introduction</span>
              </div>

              <h5 className="subtitl1">사훈</h5>
              <div className="mb40">
                <img
                  src={walkBest}
                  alt="정도 우리는 정당한 도리를 다하고 올바른 길을 걸으며 미래를 개척한다!"
                />
              </div>
              <h5 className="subtitl1">한국금거래소 핵심가치</h5>
              <ul className="step_box1">
                <li>
                  <div className="step_pic">
                    <img src={step_pc_1} alt="pic1" />
                  </div>
                  <div className="org_line">
                    <img src={orLine1} alt="line" />
                  </div>
                  <dl>
                    <dt>고객중심</dt>
                    <dd>
                      고객이 원하는 것을
                      <br />
                      파악하여 유연하고
                      <br />
                      민첩하게 제공합니다.
                    </dd>
                  </dl>
                  {/* <!--
                  <div className="step_pic">
                    <img src={ceoStep} alt="pic1" />
                  </div>
                  --> */}
                </li>
                <li>
                  <div className="step_pic">
                    <img src={step_pc_2} alt="pic2" />
                  </div>
                  <div className="org_line">
                    <img src={orLine1} alt="line" />
                  </div>
                  <dl>
                    <dt>투명성</dt>
                    <dd>
                      투명하게 정보를
                      <br />
                      제공함으로써
                      <br />
                      귀금속 거래의
                      <br />
                      기준을 세웁니다.
                    </dd>
                  </dl>
                  {/* <!--
                  <div className="step_pic">
                    <img src={ceoStep2} alt="pic2" />
                  </div>
                  --> */}
                </li>
                <li>
                  <div className="step_pic">
                    <img src={step_pc_3} alt="pic3" />
                  </div>
                  <div className="org_line">
                    <img src={orLine1} alt="line" />
                  </div>
                  <dl>
                    <dt>주인정신</dt>
                    <dd>
                      임직원 모두는
                      <br />
                      인격과 실력을 갖추고
                      <br />
                      한국금거래소의
                      <br />
                      주인으로서
                      <br />
                      생각하고 행동합니다.
                    </dd>
                  </dl>
                  {/* <!--
                  <div className="step_pic">
                    <img src={ceoStep3} alt="pic3" />
                  </div>
                  --> */}
                </li>
                <li>
                  <div className="step_pic">
                    <img src={step_pc_4} alt="pic4" />
                  </div>
                  <div className="org_line">
                    <img src={orLine1} alt="line" />
                  </div>
                  <dl>
                    <dt>소통/방법</dt>
                    <dd>
                      대리점/조직/개인 간<br />
                      벽을 허물고
                      <br />
                      수평적인 소통으로
                      <br />
                      협업을 강화합니다.
                      <br />
                    </dd>
                  </dl>
                  {/* <!--
                  <div className="step_pic">
                    <img src={ceoStep4} alt="pic4" />
                  </div>
                  --> */}
                </li>
              </ul>
            </div>
            <div className="clear"></div>
            {/* <!--contents--> */}
          </div>
        </div>
        {/* <!--**컨테이너 영역 끝--> */}
      </div>
      {/* <!-- ////// wrap --> */}
      <svg
        id="SvgjsSvg1001"
        width="2"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnssvgjs="http://svgjs.com/svgjs"
        style={{
          overflow: "hidden",
          top: "-100%",
          left: "-100%",
          position: "absolute",
          opacity: 0,
        }}
      >
        <defs id="SvgjsDefs1002"></defs>
        <polyline id="SvgjsPolyline1003" points="0,0"></polyline>
        <path id="SvgjsPath1004" d="M0 0 "></path>
      </svg>
    </>
  );
}
